/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["ig-drop-down-item{display:block;padding:8px 16px;cursor:pointer;font-size:14px}ig-drop-down-item:hover{background:rgba(0,0,0,.1)}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/common/components/drop.down/item/drop.down.item.component.scss.ngstyle.js.pre-build-optimizer.js